<template>
  <generic-config 
    :values="getCurrencies"
    displayText="symbol"
    :onSaveHandler="onSave"
    :onDeleteHandler="onDelete"
    entityName="Currency"
    >
    <template v-slot:entryForm="{selectedItem, onSaveItem, onDeleteItem}">
      <EntryForm
        :model="dataModel"
        :data="selectedItem"
        :mode="selectedItem ? 'viewEdit' : 'new'"
        @onSave="onSaveItem"
        @onDelete="onDeleteItem"
      />
    </template>
    <template v-slot:itemListing="{onItemSelected, values, displayText}">
      <item-list 
        title="" 
        :items="values"
        :itemText="displayText" 
        :clickable="true" 
        @onClick="onItemSelected"/>
    </template>
  </generic-config>
</template>

<script>
import GenericConfig from "@/components/common/GenericConfig";
import EntryForm from "@/components/common/EntryForm";
import ItemList from '@/components/common/ItemList.vue';

import { Currency, uuid } from '@/model';

export default {
  components: {
    GenericConfig,
    EntryForm,
    ItemList
  },
  async created() {
    await this.$store.dispatch("getCurrencies");
  },
  data: () => ({
    dataModel : [
        {label: 'Uuid', valueAttr: 'uuid', type: 'text', display: false},
        {label: 'Symbol', valueAttr: 'symbol', type: 'text', display: true, maxLength: 3, case:'upper', required: true},
        {label: 'Primary', valueAttr: 'primary', type: 'boolean', display: true, required: true},
      ]
  }),
  computed: {
    currencies() {
      const list =  [...this.$store.state.currencies]
        .map(cp => ({ uuid: cp.uuid, symbol: cp.symbol, primary: cp.primary}));
      return list;
    }
  },
  methods: {
    getCurrencies(cp) {
      if (!cp || !cp.uuid) {
        return this.currencies;
      }
      return this.currencies.filter(c => c.uuid !== cp.uuid);
    },
    async onSave(valueObject) {
      valueObject.uuid = valueObject.uuid || uuid();
      valueObject.primary = (valueObject.primary === undefined) ? false : valueObject.primary;
      
      const currency = Currency.fromJson(valueObject);
      await this.$store.dispatch("saveCurrency", currency);
    },
    async onDelete([valueObject]) {
      const currency = Currency.fromJson(valueObject);
      await this.$store.dispatch("deleteCurrency", currency);
    }
  }
};
</script>